'use client';
import { useRouter } from 'next/compat/router';
import { useSearchParams } from 'next/navigation';
import React, { type FC, useEffect } from 'react';

import { useLoginModal } from '../../components/LoginModal';
import ClassPage, {
  type ClassPageStaticProps,
  useClassPageRehydratedData,
} from '../../components/classes/ClassPage';
import { useAuth } from '../../context/AuthContext';
import { useLex } from '../../context/LexContext';
import { getCoachingSessionMeetingUrl } from '../../utils/coaching-session';

const PublishedEventPage: FC<ClassPageStaticProps> = ({
  staticClassData,
  pageContentProps,
  eventSlug,
}) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { isLexEnabled, isLexLoading } = useLex();
  const { currentUser, isLoadingUser } = useAuth();

  const { setOpen: setLoginModalOpen, Modal: LoginModal } = useLoginModal();

  const sessionIdToOpen = searchParams.get('openSid') as Optional<string>;

  const { data: classData, error: classDataError } = useClassPageRehydratedData(
    eventSlug ?? '',
  );

  const isLoggedInAsApplicant = !!currentUser?.applicant;
  useEffect(() => {
    if (!isLoadingUser && sessionIdToOpen && classData) {
      if (!isLoggedInAsApplicant) {
        setLoginModalOpen(true);
      }
      const sessionToOpen =
        classData.groupClassBySlug.userEnrolledInSessionsV2?.find(
          (s) => s.id === sessionIdToOpen,
        );
      if (sessionToOpen?.meetingLink) {
        void router?.push(getCoachingSessionMeetingUrl(sessionToOpen.id));
      }
    }
    if (classData && !classData.groupClassBySlug.isFreeEvent) {
      void router?.push(`/class/${eventSlug}`);
    }
  }, [
    isLoadingUser,
    sessionIdToOpen,
    classData,
    isLoggedInAsApplicant,
    router,
    setLoginModalOpen,
    eventSlug,
    isLexEnabled,
    isLexLoading,
  ]);

  return (
    <>
      <ClassPage
        error={!!classDataError}
        classData={classData?.groupClassBySlug ?? staticClassData}
        pageContentProps={pageContentProps}
        reload={() => window.location.reload()}
        trackingPrefix="PublishedEventPage"
      />
      <LoginModal hideCloseButton />
    </>
  );
};

export default PublishedEventPage;
